import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import GoalTypeModal from "../../core/modals/goalTypeModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchAllGoaltype } from "../../core/data/redux/performance/goaltype/goaltypeAction";
import {
  createGoal,
  fetchAllGoal,
  UpdateGoal,
  deleteGoal,
} from "../../core/data/redux/performance/goal/goalAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import Select from "react-select";
import { create } from "domain";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { Drawer, message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";

const Goalpage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const { user } = useSelector((state: any) => state.auth);
  const [errors, setErrors] = useState<any>({});
  const [isEditing, setIsEditing] = useState(false);
  const { goaltype } = useSelector((state: any) => state.performance.goaltype);
  const { goal, loadingStates } = useSelector((state: any) => state.performance.goal);
  const isLoading = isEditing? loadingStates.update : loadingStates.create;
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
  useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const Id = selectedRowData?.id;
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [tableKey, setTableKey] = useState(0);

  const formattedGoalType = goaltype.map((gt: any) => ({
    value: gt.Id,
    label: gt.Type,
  }));

  useEffect(() => {
    dispatch(fetchAllGoaltype());
    dispatch(fetchAllGoal());
  }, []);

  const [tabKey, setTabKey] = useState(0);

  const routes = all_routes;
  const data = goal ? goal : [];

  const filteredData = useMemo(() => {
    return filterData(
      data || [],
      { status: selectedStatus },
      "createdAt",
      "createdAt",
      selectedSort
    );
  }, [dispatch, goal, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, goal, selectedSort, selectedStatus]);

  // useEffect(() => {
  //   setTabKey((prevKey: any) => prevKey + 1);
  // }, [goaltype]);

  const [formData, setFormData] = useState<any>({
    Name: "",
    Goaltype: "",
    Weightage: null,
    Description: "",
    Status: null,
    createdBy: user.UserId,
  });

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (selectedOption: any, action: any) => {
    setFormData({ ...formData, [action.name]: selectedOption });
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      Name: "",
      Goaltype: "",
      Weightage: "",
      Description: "",
      Status: "",
    };

    if (!formData.Name) {
      formIsValid = false;
      newErrors.Name = "Name is required.";
    }

    if (!formData.Goaltype) {
      formIsValid = false;
      newErrors.Goaltype = "Goal Type is required.";
    }

    if (
      formData.Weightage === null ||
      formData.Weightage === "" ||
      isNaN(formData.Weightage)
    ) {
      formIsValid = false;
      newErrors.Weightage = "Weightage is required and must be a number.";
    }


    if (!formData.Status || formData.Status.value === "Select") {
      formIsValid = false;
      newErrors.Status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    const formattedData = {
      Name: formData.Name,
      Goaltype: formData.Goaltype.value,
      Weightage: formData.Weightage,
      Description: formData.Description,
      Status: formData.Status.value,
      ...(isEditing ? { modifiedBy: user.UserId } : { createdBy: user.UserId }),
    };

    try {
      let result;
      if (isEditing) {
        result = await dispatch(
          UpdateGoal({ goalId: Id, data: formattedData })
        );
      } else {
        result = await dispatch(createGoal(formattedData));
      }

      if (result) {
        message.success(result.payload.message);
        await dispatch(fetchAllGoal());
        setTabKey((prevKey) => prevKey + 1);

        if (!isEditing) {
          setFormData({
            Name: "",
            Goaltype: "",
            Weightage: null,
            Description: "",
            Status: null,
            createdBy: user.UserId,
          });
        }
      } else {
        message.warning("Already Exists");
      }
    } catch (error) {
      alert("An error occurred");
    }
  };

  useEffect(() => {
    if (selectedRowData) {
      setIsEditing(true);
      setFormData({
        Name: selectedRowData.name,
        Goaltype:
          formattedGoalType.find(
            (gt: any) => gt.value === Number(selectedRowData.goaltype)
          ) || null,
        Weightage: selectedRowData.weightage,
        Description: selectedRowData.description,
        Status:
          statusOptions.find((s: any) => s.value === selectedRowData.status) ||
          null,
        modifiedBy: user.UserId,
      });
    } else {
      setIsEditing(false);
      setFormData({
        Name: "",
        Goaltype: "",
        Weightage: null,
        Description: "",
        Status: null,
        createdBy: user.UserId,
      });
    }
  }, [selectedRowData]);

  const handleDeletePolicy = (Id: any) => {
    const goalId = parseInt(Id);
    dispatch(deleteGoal(goalId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          alert(resp.payload.message);
          setTimeout(() => {
            dispatch(fetchAllGoal());
            setTabKey((prevKey) => prevKey + 1);
          }, 1000);
        } else {
          setIsDeleteModalVisible(false);
          alert(resp.payload.error);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };
  const columns = [
    {
      title: "Goal",
      dataIndex: "name",
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "Goal-Type",
      dataIndex: "type_name",
      sorter: (a: any, b: any) => a.type_name.length - b.type_name.length,
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      sorter: (a: any, b: any) => a.weightage.length - b.weightage.length,
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a: any, b: any) => a.description.length - b.description.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        const badgeClass =
          text === "active" ? "badge badge-success" : "badge badge-danger";

        return (
          <span
            className={`${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

          </span>
        );
      },
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link to="#"data-bs-toggle="tooltip"
             data-bs-placement="top"
              title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                setSelectedRowData(record);
                setIsEditing(true);
                setIsDrawerVisible(true);
                setErrors({});
              }}
            />
          </Link>
          <Link to="#"data-bs-toggle="tooltip"
             data-bs-placement="top"
               title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
            />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Goal</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Performance</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Add New Goal{" "}
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="mb-2">
              <Link
                to="#"
                className="btn btn-primary d-flex align-items-center"
                onClick={() => {
                  setIsEditing(false);
                  setFormData({
                    Name: "",
                    Goaltype: "",
                    Weightage: null,
                    Description: "",
                    Status: null,
                    createdBy: user.UserId,
                  });
                  setIsDrawerVisible(true);
                  setErrors({});
                }}
              >
                <i className="ti ti-circle-plus me-2" />
                Add Goal{" "}
              </Link>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Performance Indicator list */}
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>Goal Lists</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-3">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {selectedStatus
                    ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                    : "Select Status"}
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedStatus("active")}
                      className="dropdown-item rounded-1"
                    >
                      Active
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedStatus("inactive")}
                      className="dropdown-item rounded-1"
                    >
                      Inactive
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {selectedSort
                    ? `Sort By : ${selectedSort}`
                    : "Sort By : Last 7 Days"}
                </Link>
                <ul className="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Recently Added")}
                      className="dropdown-item rounded-1"
                    >
                      Recently Added
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Ascending")}
                      className="dropdown-item rounded-1"
                    >
                      Ascending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Descending")}
                      className="dropdown-item rounded-1"
                    >
                      Descending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Last Month")}
                      className="dropdown-item rounded-1"
                    >
                      Last Month
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Last 7 Days")}
                      className="dropdown-item rounded-1"
                    >
                      Last 7 Days
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <Table
              key={tableKey}
              dataSource={filteredData}
              columns={columns}
              Selection={true}
            />
          </div>
        </div>
        {/* /Performance Indicator list */}
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>

      <Drawer
        title={isEditing ? "Update Goal " : "Create Goal"}
        placement="right"
        onClose={() => setIsDrawerVisible(false)}
        open={isDrawerVisible}
        width={480}
        style={{ marginTop: 50 }}
      >
        <form onSubmit={handleFormSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="Name"
                    className="form-control"
                    value={formData.Name}
                    onChange={handleChange}
                  />
                  {errors.Name && (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Goal Type <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={formattedGoalType.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    value={formData.Goaltype}
                    onChange={handleSelectChange}
                    name="Goaltype"
                  />
                  {errors.Goaltype && (
                    <div style={{ color: "red" }}>{errors.Goaltype}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Weightage <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    name="Weightage"
                    className="form-control"
                    value={formData.Weightage}
                    onChange={handleChange}
                  />
                  {errors.Weightage && (
                    <div style={{ color: "red" }}>{errors.Weightage}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={statusOptions}
                    value={formData.Status}
                    onChange={handleSelectChange}
                    name="Status"
                  />
                  {errors.Status && (
                    <div style={{ color: "red" }}>{errors.Status}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description 
                  </label>
                  <textarea
                    name="Description"
                    className="form-control"
                    value={formData.Description}
                    onChange={handleChange}
                  />
                  {errors.Description && (
                    <div style={{ color: "red" }}>{errors.Goaltype}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIsDrawerVisible(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {isEditing ? "Update Goal" : "Add Goal"}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => Id && handleDeletePolicy(Id)}
      />
    </>
  );
};

export default Goalpage;
